const isAuthenticated = () => localStorage.getItem("token") !== null;

export { isAuthenticated };
